module.exports = __webpack_public_path__ + "img/_DSC7469.9ac335ea.jpg";